export const API_URL_ENV_NAME_START = 'VITE_API_URL_'
export const API_PROXY_ENV_NAME_START = 'VITE_API_PROXY_'
